import PhotoSwipeLightbox from './esm-modules/photoswipe-lightbox.esm.min.js';
import PhotoSwipe from './esm-modules/photoswipe.esm.min.js';

var ttLightBox = {
  init: function () {
    const lightbox = new PhotoSwipeLightbox({
      gallery: '.pswp-gallery',
      children: 'a.img',
      zoom: false,
      bgOpacity: 1,
      loop: false,
      // wheelToZoom: true,
      // clickToCloseNonZoomable: false,
      reloaderDelay: 1000,
      paddingFn: (viewportSize, itemData, index) => {
        return {
          top: viewportSize.x >= 1440 ? 60 : 0,
          bottom: viewportSize.x >= 1440 ? 60 : 0,
          left: viewportSize.x >= 1440 ? 80 : 0,
          right: viewportSize.x >= 1440 ? 80 : 0
        };
      },
      pswpModule: PhotoSwipe
    });

    lightbox.addFilter('itemData', (itemData, index) => {
      const videoSrc = itemData.element.dataset.pswpVideoSrc;
      if (videoSrc) {
        itemData.videoSrc = videoSrc;
      }
      return itemData;
    });

    lightbox.on('contentLoad', (e) => {
      const { content } = e;
      
      if (content.data.videoSrc) {
        e.preventDefault();

        content.video_wrap_el = document.createElement('div');
        content.video_wrap_el.className = 'pswp__video-wrap video-wrap p-abs top lt rt btm';
        
        const video_el = document.createElement('video');
        video_el.className = 'full';
        video_el.setAttribute('playsinline', '');
        video_el.setAttribute('webkit-playsinline', '');
        video_el.setAttribute('controls', '');
        video_el.setAttribute('controlsList', 'nodownload');

        const source_el = document.createElement('source');
        source_el.src = content.data.videoSrc;
        source_el.setAttribute('type', 'video/mp4');

        const cover_wrap_el = document.createElement('div');
        cover_wrap_el.className = 'cover img-wrap coverbg p-abs top full flex-centerbox trans3d0';
        cover_wrap_el.style = 'background-image:url(' + content.data.src + ')';

        // const btn_el = document.createElement('div');
        // btn_el.className = 'video-btn-play trans';

        // const icon_el = `<svg class="icon full" viewBox="0 0 24 24"><path d="M9.5 9.325v5.35q0 .575.525.875t1.025-.05l4.15-2.65q.475-.3.475-.85t-.475-.85L11.05 8.5q-.5-.35-1.025-.05t-.525.875ZM12 22q-2.075 0-3.9-.788t-3.175-2.137q-1.35-1.35-2.137-3.175T2 12q0-2.075.788-3.9t2.137-3.175q1.35-1.35 3.175-2.137T12 2q2.075 0 3.9.788t3.175 2.137q1.35 1.35 2.138 3.175T22 12q0 2.075-.788 3.9t-2.137 3.175q-1.35 1.35-3.175 2.138T12 22Z"></path></svg>`;

        // btn_el.innerHTML = icon_el;

        content.element = document.createElement('img');
        content.element.src = content.data.src;
        content.element.setAttribute('alt', '');
        content.element.className = 'pswp__img';

        video_el.appendChild(source_el);
        // cover_wrap_el.appendChild(btn_el);
        content.video_wrap_el.appendChild(video_el);
        content.video_wrap_el.appendChild(cover_wrap_el);

        content.state = 'loading';

        if (content.element.complete) {
          content.onLoaded();
        } else {
          content.element.onload = () => {
            content.onLoaded();
          };

          content.element.onerror = () => {
            content.onError();
          };
        }
      }
    });

    lightbox.on('contentAppend', (e) => {
      const {content} = e;
      if (content.video_wrap_el && !content.video_wrap_el.parentNode) {
        e.preventDefault();
        content.slide.container.className += ' pswp__tt-video-wrap';
        content.slide.container.appendChild(content.element);
        content.slide.container.appendChild(content.video_wrap_el);
        ttVideo.init();
        ttVideo.play($(content.video_wrap_el));
      }
    });

    lightbox.on('contentRemove', (e) => {
      const {content} = e;
      if (content.video_wrap_el && content.video_wrap_el.parentNode) {
        e.preventDefault();
        content.video_wrap_el.remove();
        // content.element.remove();
      }
    });

    lightbox.on('contentActivate', ({ content }) => {
      if (content.video_wrap_el) ttVideo.init();
    });

    lightbox.on('contentDeactivate', ({ content }) => {
      if (content.video_wrap_el) ttVideo.pause($(content.video_wrap_el));
    });

    lightbox.on('pointerDown', (e) => {
      var el = $(e.originalEvent['target']);
      if (el.is('.pswp__button--arrow')) $('.pswp__container').addClass('anim_trans');
      else $('.pswp__container').removeClass('anim_trans');
    });

    // lightbox.on('afterInit', () => {
    //   // photoswipe fully initialized and opening transition is running (if available)
    //   $('.pswp__button--arrow').off('click.tt').on('click.tt', function () {
    //     $('.pswp__container').addClass('anim_trans');
    //   });

    //   $('.pswp__container').mousedown(function () {
    //     console.log('mouse down');
    //     $(this).removeClass('anim_trans');
    //   });
    // });

    // lightbox.on('change', () => {
    //   console.log('change');

    //   $('.pswp__container').addClass('anim_trans').one(tt_transition_end, function () {
    //     $(this).removeClass('anim_trans');
    //   });
    // });

    lightbox.on('closingAnimationStart', () => {
      $('.pswp__video-wrap').removeClass('showvideo').find('.video-btn-play').remove();
    });

    lightbox.init();
    window.tt_lightbox = lightbox;
  },

  close: function () {
    var pswp = window.tt_lightbox.pswp;
    if(pswp) pswp.close();
  }
}

jQuery(document).ready(function ($) {
  ttLightBox.init();
})